import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  component_styles_default
} from "./chunk.BKUJPVXD.js";
import {
  $,
  r,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/menu-label/menu-label.ts
var FadvMenuLabel = class extends s {
  render() {
    return $`<div part="base" class="menu-label"><fadv-typography type="label-small" weight="500"><slot></slot></fadv-typography><span part="suffix" class="menu-label__suffix"><slot name="suffix"></slot></span></div>`;
  }
};
FadvMenuLabel.styles = r` ${component_styles_default} :host { display: block; } .menu-label { color: var(--sl-color-gray-700); padding: 0 var(--sl-spacing-small); user-select: none; text-align: start; display: flex; align-items: center; margin: var(--sl-spacing-2x-small) var(--sl-spacing-3x-small); } fadv-typography { display: block; width: 100%; } fadv-typography::part(base) { text-transform: uppercase; line-height: 1rem; } .menu-label .menu-label__suffix { flex: 0 0 auto; display: flex; align-items: center; } .menu-label .menu-label__suffix ::slotted(*) { margin-left: var(--sl-spacing-x-small); } `;
FadvMenuLabel = __decorateClass([
  n("fadv-menu-label")
], FadvMenuLabel);

export {
  FadvMenuLabel
};
